import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  container: {
  },
  label: {
    fontSize: 12,
    fontWeight: 700,
    color: neutrals.neutralGrays.graphite,
    marginBottom: 8,
  },
  dropdown: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 14,
  },
  selectedText: {
    fontSize: 14,
    color: neutrals.neutralGrays.graphite,
  },
  dropdownList: {
    overflow: 'hidden',
  },
  option: {
    paddingVertical: 10,
    paddingHorizontal: 14,
  },
  optionText: {
    fontSize: 14,
    color: neutrals.black,
  },
  optionTextSelected: {
    fontSize: 14,
    color: brand.main.water,
  },
  dropdownContainer: {
    borderWidth: 1,
    borderColor: neutrals.neutralGrays.dust,
    borderRadius: 12,
    backgroundColor: neutrals.white,
    overflow: 'hidden',
  },
  hover: {
    backgroundColor: brand.main.variations['lighterWater-3'],
  },
});
